// 后台管理国际化工具
const translations = {
  zh: {
    // 导航菜单
    'dashboard': '仪表板',
    'users': '用户管理',
    'orders': '订单管理',
    'api_keys': 'API Keys',
    'providers': '模型管理',
    'affiliates': '商户管理',
    'activity_center': '活动中心',
    'feedbacks': '工单反馈',
    'customer_service_config': '客服配置',
    'system_settings': '营销管理',
    'payment_settings': '支付配置',
    'usage_statistics': '用量统计',
    'sms_config': '短信配置',
    'settings': '基础配置',
    'system_maintenance': '系统维护',
    'laboratory': '科学实验室',
    'batch_tasks': '批量任务',

    // 用户信息
    'admin': '管理员',
    'logout': '退出登录',

    // 通用
    'loading': '加载中...',
    'save': '保存',
    'cancel': '取消',
    'id': 'ID',
    'confirm': '确认',
    'delete': '删除',
    'edit': '编辑',
    'create': '创建',
    'search': '搜索',
    'reset': '重置',
    'success': '成功',
    'error': '错误',

    // 用户管理
    'user_list': '用户列表',
    'username': '用户名',
    'email': '邮箱',
    'phone': '手机号',
    'balance': '余额',
    'status': '状态',
    'created_at': '创建时间',
    'actions': '操作',
    'active': '启用',
    'inactive': '禁用',
    'recharge': '充值',
    'recharge_amount': '充值金额',
    'is_affiliate': '是否商户',
    'set_affiliate': '设为商户',
    'cancel_affiliate': '取消商户',

    // 订单管理
    'order_list': '订单列表',
    'order_no': '订单号',
    'user': '用户',
    'amount': '金额',
    'type': '类型',
    'time': '时间',

    // 系统设置
    'site_name': '站点名称',
    'site_desc': '站点描述',
    'api_config': 'API 配置',

    // 登录
    'login': '登录',
    'password': '密码',
    'captcha': '验证码',
    'login_success': '登录成功',
    'login_failed': '登录失败',
    'logout_success': '已退出登录',

    // 插件管理
    'plugins': '插件管理',
    'plugin_management': '插件管理',
    'plugin_list': '插件列表',
    'built_in_plugins': '内置插件',
    'custom_plugins': '自定义插件',
    'plugin_name': '插件名称',
    'plugin_display_name': '显示名称',
    'plugin_type': '类型',
    'plugin_description': '描述',
    'plugin_code': '代码',
    'plugin_language': '语言',
    'plugin_status': '状态',
    'plugin_creator': '创建者',
    'plugin_created_at': '创建时间',
    'plugin_updated_at': '更新时间',
    'plugin_is_public': '是否公开',
    'create_plugin': '创建插件',
    'edit_plugin': '编辑插件',
    'delete_plugin': '删除插件',
    'confirm_delete_plugin': '确认删除插件',
    'delete_plugin_warning': '确定要删除此插件吗？此操作无法撤销。',
    'plugin_created': '插件创建成功',
    'plugin_updated': '插件更新成功',
    'plugin_deleted': '插件删除成功',
    'plugin_execution_log': '执行日志',
    'no_plugins': '暂无插件',
    'no_custom_plugins': '暂无自定义插件',
    'execution_time': '执行时间',
    'execution_status': '状态',
    'execution_success': '成功',
    'execution_failed': '失败',
    'javascript': 'JavaScript',
    'python': 'Python',
    'lua': 'Lua',
    'all': '全部',
    // 通用字段
    'required_field': '不能为空',
    'detail': '详情',
    'total': '总计',
    'yes': '是',
    'no': '否',
    'close': '关闭',
    'search_placeholder': '搜索名称、描述...',
    'clear_filters': '清除筛选',
    // 插件管理
    'built_in': '内置',
    'custom': '自定义',
    'built_in_plugin_tip': '内置插件为系统预置功能，无法编辑或删除，仅可执行测试。',
    'plugin_detail': '插件详情',
    'plugin_display_name_placeholder': '插件的友好显示名称',
    'plugin_description_placeholder': '简要描述插件的功能和用途',
    'code_template_tip': '插件代码需要实现处理函数，接收 params 参数并返回处理结果',
    'code_placeholder': '// 编写你的插件代码...',
    'execute_plugin': '执行插件',
    'execution_params': '执行参数 (JSON)',
    'execution_result': '执行结果',
    'delete_failed': '删除失败',
    // 预设管理
    'presets': '预设管理',
    'preset_management': '预设管理',
    'preset_name': '预设名称',
    'preset_description': '描述',
    'preset_temperature': '温度',
    'preset_max_tokens': '最大Token',
    'preset_is_public': '是否公开',
    'preset_use_count': '使用次数',
    'preset_clone_count': '克隆次数',
    'preset_created_at': '创建时间',
    'preset_updated_at': '更新时间',
    'preset_deleted': '预设删除成功',
    'preset_cloned': '预设克隆成功',
    'preset_preview': '预设预览',
    'system_prompt': '系统提示词',
    'total_presets': '预设总数',
    'public_presets': '公开预设',
    'private_presets': '私有预设',
    'total_uses': '总使用次数',
    'search_preset_placeholder': '搜索名称、描述、提示词...',
    'filter_by_user_id': '按用户ID筛选',
    'confirm_delete_preset': '确认删除预设',
    'delete_preset_warning': '确定要删除此预设吗？此操作无法撤销。',
    'clone': '克隆',
    'clone_preset': '克隆预设',
    'clone_preset_tip': '克隆预设将创建一个新的私有副本，您可以自定义修改。',
    'preset_name_required': '请输入预设名称',
    'enter_preset_name': '请输入预设名称',
    'clone_failed': '克隆失败',
    'preview': '预览',
    'approval_status': '审核状态',
    'pending_review': '待审核',
    'approved': '已通过',
    'rejected': '已拒绝',
    'approve': '通过',
    'reject': '拒绝',

    // 用量限额管理
    'rate_limit_management': '用量限额',
    'rate_limit_config': '限流配置',
    'current_config': '当前配置',
    'limit': '限额',
    'user_limit': '用户限流',
    'key_limit': 'API Key限流',
    'ip_limit': 'IP限流',
    'model_limit': '模型限流',
    'active_users': '活跃用户',
    'active_keys': '活跃Keys',
    'active_ips': '活跃IPs',
    'blocked_count': '被限流数',
    'users_blocked': '个用户被限流',
    'requests_in_window': '窗口内请求',
    'usage_rate': '使用率',
    'confirm_reset': '确定要重置限流计数吗？',
    'config': '配置',
    'refresh': '刷新',
    'per': '次/',
    'models_configured': '个模型已配置',
    'window_seconds': '窗口(秒)',
    'set_user_limit': '设置用户限流',
    'model_list': '模型列表',
    'add_model_limit': '添加模型限流',
    'edit_model_limit': '编辑模型限流',
    'model_edited_success': '模型限流编辑成功',
    'configured_model_limits': '已配置的模型限流',
    'no_model_limits_configured': '暂无模型限流配置',
    'no_model_usage_data': '暂无模型用量数据',
    'model_name_hint': '输入模型名称，如 deepseek-v4-flash, qwen-turbo, gpt-4o',
    'limit_per_window': '时间窗口内的最大请求次数',
    'add': '添加',

    // 路由管理
    'route_router': '智能路由',
     'ai_qudao': '渠道管理',
    'health_monitor': '健康监控',
    'route_strategies': '路由策略',
    'route_test': '路由测试',
    'available_models': '可用模型',
    'fallback_config': '备用配置',
    'retry_config': '重试配置',
    'strategy_name': '策略名称',
    'strategy_key': '策略标识',
    'strategy_description': '策略说明',
    'strategy_tip': '智能路由会自动根据策略选择最优模型进行请求，失败时自动切换备用模型',
    'test_route': '测试',
    'model_name': '模型名称',
    'display_name': '显示名称',
    'provider': '供应商',
    'input_price': '输入价格',
    'output_price': '输出价格',
    'quality_score': '质量评分',
    'success_rate': '成功率',
    'model_type': '模型类型',
    'strategy': '策略',
    'max_cost_per_request': '单次最大成本',
    'start_test': '开始测试',
    'test_result': '测试结果',
    'selected_model': '选定模型',
    'route_method': '路由方式',
    'cost_estimation': '成本估算',
    'fallback_models': '备用模型',
    'select_fallback_models': '选择备用模型',
    'save_config': '保存配置',
    'current_fallback': '当前备用模型',
    'total_requests': '总请求数',
    'avg_latency': '平均延迟',
    'failed_requests': '失败请求',
    'max_retries': '最大重试次数',
    'initial_delay': '初始延迟',
    'max_delay': '最大延迟',
    'backoff_factor': '退避因子',

    // 批处理管理
    'batch_management': '批量任务管理',
    'batch_detail': '批量任务详情',
    'batch_type': '类型',
    'batch_status': '状态',
    'batch_user': '用户',
    'batch_user_id': '用户 ID',
    'batch_input_file': '输入文件',
    'batch_output_file': '输出文件',
    'batch_error_file': '错误文件',
    'batch_completed_at': '完成时间',
    'batch_cancel_before': '截止取消时间',
    'batch_completion_window': '完成窗口',
    'batch_metadata': '元数据',
    'batch_processing': '处理中',
    'batch_cancelled': '已取消',
    'batch_input_file_id': '输入文件ID',
    'batch_inputs': '输入数据',
    'batch_refresh': '刷新',

    // 订单管理
    'order_management': '订单管理',
    'export': '导出',
    'export_success': '导出成功',
    'confirm_export': '确认导出',
    'export_orders_tip': '将导出当前筛选条件下的所有订单数据（CSV 格式）',
    'no_data_export': '没有数据可导出',
    'fetch_orders_failed': '获取订单列表失败',
    'total_orders': '总订单',
    'pending_orders': '处理中',
    'succeeded_orders': '成功',
    'failed_orders': '失败',
    'cancelled_orders': '已取消',
    'total_amount': '总金额',
    'order_status': '订单状态',
  },
  en: {
    // Navigation
    'dashboard': 'Dashboard',
    'users': 'Users',
    'orders': 'Orders',
    'api_keys': 'API Keys',
    'providers': 'Models',
    'affiliates': 'Merchants',
    'activity_center': 'Activity Center',
    'feedbacks': 'Feedbacks',
    'customer_service_config': 'Service Config',
    'system_settings': 'Marketing',
    'payment_settings': 'Payment Config',
    'usage_statistics': 'Usage Statistics',
    'sms_config': 'SMS Config',
    'settings': 'System Config',
    'system_maintenance': 'Maintenance',
    'laboratory': 'Scientific Lab',
    'batch_tasks': 'Batch Tasks',
    'plugins': 'Plugins',

    // Plugin Management
    'plugin_management': 'Plugin Management',
    'plugin_list': 'Plugin List',
    'built_in_plugins': 'Built-in Plugins',
    'custom_plugins': 'Custom Plugins',
    'plugin_name': 'Plugin Name',
    'plugin_display_name': 'Display Name',
    'plugin_type': 'Type',
    'plugin_description': 'Description',
    'plugin_code': 'Code',
    'plugin_language': 'Language',
    'plugin_status': 'Status',
    'plugin_creator': 'Creator',
    'plugin_created_at': 'Created At',
    'plugin_updated_at': 'Updated At',
    'plugin_is_public': 'Public',
    'create_plugin': 'Create Plugin',
    'edit_plugin': 'Edit Plugin',
    'delete_plugin': 'Delete Plugin',
    'confirm_delete_plugin': 'Confirm Delete Plugin',
    'delete_plugin_warning': 'Are you sure you want to delete this plugin? This action cannot be undone.',
    'plugin_created': 'Plugin created successfully',
    'plugin_updated': 'Plugin updated successfully',
    'plugin_deleted': 'Plugin deleted successfully',
    'plugin_execution_log': 'Execution Log',
    'no_plugins': 'No plugins found',
    'no_custom_plugins': 'No custom plugins yet',
    'execution_time': 'Execution Time',
    'execution_status': 'Status',
    'execution_success': 'Success',
    'execution_failed': 'Failed',
    'javascript': 'JavaScript',
    'python': 'Python',
    'lua': 'Lua',
    'all': 'All',
    // Common fields
    'required_field': ' is required',
    'id': 'ID',
    'detail': 'Detail',
    'total': 'Total',
    'yes': 'Yes',
    'no': 'No',
    'close': 'Close',
    'search_placeholder': 'Search name, description...',
    'clear_filters': 'Clear Filters',
    // Plugin management
    'built_in': 'Built-in',
    'custom': 'Custom',
    'built_in_plugin_tip': 'Built-in plugins are pre-installed by the system. They cannot be edited or deleted, only executed for testing.',
    'plugin_detail': 'Plugin Detail',
    'plugin_display_name_placeholder': 'Friendly display name for the plugin',
    'plugin_description_placeholder': 'Brief description of plugin functionality',
    'code_template_tip': 'Plugin code must implement a process function that receives params and returns results',
    'code_placeholder': '// Write your plugin code...',
    'execute_plugin': 'Execute Plugin',
    'execution_params': 'Execution Parameters (JSON)',
    'execution_result': 'Execution Result',
    'delete_failed': 'Delete failed',
    // Preset Management
    'presets': 'Presets',
    'preset_management': 'Preset Management',
    'preset_name': 'Preset Name',
    'preset_description': 'Description',
    'preset_temperature': 'Temperature',
    'preset_max_tokens': 'Max Tokens',
    'preset_is_public': 'Public',
    'preset_use_count': 'Use Count',
    'preset_clone_count': 'Clone Count',
    'preset_created_at': 'Created At',
    'preset_updated_at': 'Updated At',
    'preset_deleted': 'Preset deleted successfully',
    'preset_cloned': 'Preset cloned successfully',
    'preset_preview': 'Preset Preview',
    'system_prompt': 'System Prompt',
    'total_presets': 'Total Presets',
    'public_presets': 'Public Presets',
    'private_presets': 'Private Presets',
    'total_uses': 'Total Uses',
    'search_preset_placeholder': 'Search name, description, prompt...',
    'filter_by_user_id': 'Filter by User ID',
    'confirm_delete_preset': 'Confirm Delete Preset',
    'delete_preset_warning': 'Are you sure you want to delete this preset? This action cannot be undone.',
    'clone': 'Clone',
    'clone_preset': 'Clone Preset',
    'clone_preset_tip': 'Cloning will create a new private copy that you can customize.',
    'preset_name_required': 'Please enter preset name',
    'enter_preset_name': 'Enter preset name',
    'clone_failed': 'Clone failed',
    'preview': 'Preview',
    'approval_status': 'Approval Status',
    'pending_review': 'Pending',
    'approved': 'Approved',
    'rejected': 'Rejected',
    'approve': 'Approve',
    'reject': 'Reject',

    // Rate Limit Management
    'rate_limit_management': 'Rate Limits',
    'rate_limit_config': 'Rate Limit Config',
    'current_config': 'Current Config',
    'limit': 'Limit',
    'user_limit': 'User Limit',
    'key_limit': 'API Key Limit',
    'ip_limit': 'IP Limit',
    'model_limit': 'Model Limit',
    'active_users': 'Active Users',
    'active_keys': 'Active Keys',
    'active_ips': 'Active IPs',
    'blocked_count': 'Blocked',
    'users_blocked': 'users blocked',
    'requests_in_window': 'Requests in Window',
    'usage_rate': 'Usage Rate',
    'confirm_reset': 'Confirm to reset rate limit?',
    'config': 'Config',
    'refresh': 'Refresh',
    'per': '/',
    'models_configured': 'models configured',
    'window_seconds': 'Window (seconds)',
    'set_user_limit': 'Set User Limit',
    'add_model_limit': 'Add Model Limit',
    'edit_model_limit': 'Edit Model Limit',
    'model_edited_success': 'Model limit edited successfully',
    'configured_model_limits': 'Configured Model Limits',
    'no_model_limits_configured': 'No model limits configured',
    'no_model_usage_data': 'No model usage data',
    'model_name_hint': 'Enter model name, e.g. deepseek-v4-flash, qwen-turbo, gpt-4o',
    'limit_per_window': 'Max requests per time window',
    'add': 'Add',

    // Route Router
    'route_router': 'Smart Router',
    'ai_qudao': 'Ai Providers',
    'health_monitor': 'Health Monitor',
    'route_strategies': 'Route Strategies',
    'route_test': 'Route Test',
    'available_models': 'Available Models',
    'fallback_config': 'Fallback Config',
    'retry_config': 'Retry Config',
    'strategy_name': 'Strategy Name',
    'strategy_key': 'Strategy Key',
    'strategy_description': 'Strategy Description',
    'strategy_tip': 'Smart routing automatically selects the optimal model based on strategy',
    'test_route': 'Test',
    'model_name': 'Model Name',
    'display_name': 'Display Name',
    'provider': 'Provider',
    'input_price': 'Input Price',
    'output_price': 'Output Price',
    'quality_score': 'Quality Score',
    'success_rate': 'Success Rate',
    'model_type': 'Model Type',
    'strategy': 'Strategy',
    'max_cost_per_request': 'Max Cost Per Request',
    'start_test': 'Start Test',
    'test_result': 'Test Result',
    'selected_model': 'Selected Model',
    'route_method': 'Route Method',
    'cost_estimation': 'Cost Estimation',
    'fallback_models': 'Fallback Models',
    'select_fallback_models': 'Select Fallback Models',
    'save_config': 'Save Config',
    'current_fallback': 'Current Fallback Models',
    'total_requests': 'Total Requests',
    'avg_latency': 'Avg Latency',
    'failed_requests': 'Failed Requests',
    'max_retries': 'Max Retries',
    'initial_delay': 'Initial Delay',
    'max_delay': 'Max Delay',
    'backoff_factor': 'Backoff Factor',
    'model_list': 'Model List',

    // Batch Processing
    'batch_management': 'Batch Task Management',
    'batch_detail': 'Batch Task Detail',
    'batch_type': 'Type',
    'batch_status': 'Status',
    'batch_user': 'User',
    'batch_user_id': 'User ID',
    'batch_input_file': 'Input File',
    'batch_output_file': 'Output File',
    'batch_error_file': 'Error File',
    'batch_completed_at': 'Completed At',
    'batch_cancel_before': 'Cancel Before',
    'batch_completion_window': 'Completion Window',
    'batch_metadata': 'Metadata',
    'batch_processing': 'Processing',
    'batch_cancelled': 'Cancelled',
    'batch_input_file_id': 'Input File ID',
    'batch_inputs': 'Input Data',
    'batch_refresh': 'Refresh',
  },
};

// 获取翻译
export const t = (key, params = {}) => {
  const lang = localStorage.getItem('lang') || 'zh';
  let text = translations[lang]?.[key] || translations['zh']?.[key] || key;
  
  // 替换参数
  Object.keys(params).forEach(param => {
    text = text.replace(new RegExp(`{${param}}`, 'g'), params[param]);
  });
  
  return text;
};

// 获取当前语言
export const getLang = () => localStorage.getItem('lang') || 'zh';

// 设置语言
export const setLang = (lang) => {
  localStorage.setItem('lang', lang);
};

export default { t, getLang, setLang };
